/* PD Questions couronnes : retournement des cartes uniquement au clic / tap / clavier
   (une seule carte retournée à la fois), flèches et barre de progression du carrousel.
   Les réponses sont déjà dans le HTML. */
(function () {
  function initFaq(root) {
    if (!root || root.dataset.pdFaqReady) return;
    root.dataset.pdFaqReady = 'true';

    const track = root.querySelector('.pd-faq__track');
    const prev = root.querySelector('.pd-faq__arrow--prev');
    const next = root.querySelector('.pd-faq__arrow--next');
    const progress = root.querySelector('.pd-faq__progress');
    const cards = [...root.querySelectorAll('.pd-faq__card')];
    if (!track) return;

    const setFlipped = (card, flipped) => {
      if (flipped) {
        cards.forEach((other) => {
          if (other !== card && other.classList.contains('is-flipped')) setFlipped(other, false);
        });
      }
      card.classList.toggle('is-flipped', flipped);
      card.closest('.pd-faq__item').classList.toggle('is-flipped', flipped);
      card.querySelector('.pd-faq__toggle').setAttribute('aria-expanded', String(flipped));
    };

    cards.forEach((card) => {
      const toggle = card.querySelector('.pd-faq__toggle');
      const back = card.querySelector('.pd-faq__face--back');

      toggle.addEventListener('click', () => {
        setFlipped(card, !card.classList.contains('is-flipped'));
      });

      // Verso : un clic (y compris sur « Retourner ») remet la carte côté question
      back.addEventListener('click', () => {
        if (card.classList.contains('is-flipped')) {
          setFlipped(card, false);
          toggle.focus({ preventScroll: true });
        }
      });
    });

    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = cards.find((card) => card.classList.contains('is-flipped'));
      if (open) {
        setFlipped(open, false);
        open.querySelector('.pd-faq__toggle').focus();
      }
    });

    const step = () => {
      const item = track.querySelector('.pd-faq__item');
      return item ? item.getBoundingClientRect().width * 0.9 : track.clientWidth * 0.8;
    };

    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      const ratio = max > 0 ? track.scrollLeft / max : 1;
      const visible = max > 0 ? track.clientWidth / track.scrollWidth : 1;
      if (progress) {
        progress.style.setProperty('--progress', `${Math.min(100, (visible + (1 - visible) * ratio) * 100)}%`);
      }
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    };

    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    // Éditeur de thème : sélectionner un bloc fait défiler jusqu'à sa carte et la retourne
    root.addEventListener('shopify:block:select', (event) => {
      const card = cards.find((c) => c.dataset.blockId === event.detail.blockId);
      if (!card) return;
      const item = card.closest('.pd-faq__item');
      track.scrollTo({ left: item.offsetLeft - track.offsetLeft - 40, behavior: 'smooth' });
      setFlipped(card, true);
    });
    root.addEventListener('shopify:block:deselect', () => cards.forEach((c) => setFlipped(c, false)));
  }

  const initAll = (scope) => scope.querySelectorAll('[data-pd-faq]').forEach(initFaq);

  initAll(document);
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
